import { Big as LocalBig } from 'big.js'

LocalBig.DP = 50

export const Big = LocalBig
